import React, { Fragment } from 'react';
import { formatToINR } from 'Utils/transform';
import { ReactComponent as InfoIcon } from 'Icons/info.svg';
import Overlay from 'Components/Overlay/index';
import Heading from 'Components/Heading';
import { ReactComponent as CloseIcon } from 'Icons/close.svg';
import Input from 'Components/Input'
import Dropdown from 'Components/Dropdown';
import { COST_TYPE } from 'Constants/commonConstants';
export const RFQMultiModalTripsTable = ({ lineItem, handleShowCharges, showCharges, leg, pricingBasis, onHCChange, update, currencyTypes }) => {
    const currencyType = (currencyTypes || []).find(el => el.currency_type == lineItem.legCostValue) || {};
   return (
      <Fragment>
         <div>
            <div className="flex flex-row flex flex-between flex-middle">
               {lineItem.rfqType !== 3 ?
                  <span className="section-sub-header-color fBold fs-16">
                     Legs
                </span> : <span className="section-sub-header-color fBold fs-16">

                  </span>}
               {!lineItem.hideCeilingPrice && <span className="section-sub-header-color fBold fs-16">
                  <span className="fRegular fs-16 mr-5">Total Price </span> <span> {formatToINR(lineItem.totalPrice || 0)} </span>
               </span>}
            </div>
            <div className="flex pv-20 border-bottom-light flex-between flex-middle" >
               <div className="flex col-6">
                  <span className="section-sub-header-color fBold fs-14 op-5">
                     From
                    </span>
               </div>
               <div className="flex col-6">
                  <span className="section-sub-header-color fBold fs-14 op-5">
                     To
                    </span>
               </div>
               {lineItem.rfqType !== 3 ?
                  <div className="flex col-6">
                     <span className="section-sub-header-color fBold fs-14 op-5">
                        Leg Type
                    </span>
                  </div>
                  :
                  <div className="flex col-6">
                     <span className="section-sub-header-color fBold fs-14 op-5">
                        KM Run <br></br>(Approx)
                    </span>
                  </div>}

               {lineItem.rfqType !== 3 ?
                  <div className="flex col-6">
                     <span className="section-sub-header-color fBold fs-14 op-5">
                        Volume
                    </span>
                  </div>
                  :
                  <div className="flex col-6">
                     <span className="section-sub-header-color fBold fs-14 op-5">
                        Upto
                    </span>
                  </div>}
               <div className="flex col-6">
                  <span className="section-sub-header-color fBold fs-14 op-5">
                     TAT
                    </span>
               </div>
               <div className="flex col-6">
                    <span className="section-sub-header-color fBold fs-14 op-5">
                        {lineItem.rfqType ===5 ? 'Ceiling Price' : 'Budget'}
                    </span>
               </div>
            </div>
            {
               lineItem.legs.length > 0 ? lineItem.legs.map((leg, index) => {
                  return <div className="flex pv-20 border-bottom-light flex-between flex-middle" key={index}>
                     <div className="flex col-6">
                        <span className="section-sub-header-color  fs-14">
                           {(leg.from.location ? leg.from.location : leg.from) || lineItem.from}
                        </span>
                     </div>
                     <div className="flex col-6">
                        <span className="section-sub-header-color  fs-14">
                           {leg.to.location ? leg.to.location : ((typeof(leg.to) === 'object') ? '' : leg.to)}
                        </span>
                     </div>
                     <div className="flex col-6">
                        {lineItem.rfqType !== 3 ?
                           <span className="section-sub-header-color  fs-14">
                              {leg.legTypeName}
                           </span> :
                           <span className="section-sub-header-color  fs-14">
                              {lineItem.secKmRun}
                           </span>
                        }
                     </div>
                     <div className="flex col-6">
                        {lineItem.rfqType !== 3 ?
                           <span className="section-sub-header-color  fs-14">
                              {leg.businessVolumeUnitValue} {leg.businessVolumeUnitName}
                           </span> :
                           <span className="section-sub-header-color  fs-14">
                              {lineItem.secUptoKM}
                           </span>
                        }
                     </div>
                     <div className="flex col-6">
                        <span className="section-sub-header-color  fs-14">
                           {leg.tatValue} {leg.tatUnitName}
                        </span>
                     </div>
                     <div className="col-6">
                        {lineItem.rfqType === 2 &&
                           <span className="section-sub-header-color  fs-14">
                              {leg.legBudget}
                        </span>}
                           {lineItem.rfqType === 3 && <span className="section-sub-header-color  fs-14">
                              {lineItem.secondaryQbr}
                           </span>}
                           {lineItem.rfqType === 5 &&
                           <Fragment>
                           <span className="section-sub-header-color  fs-14">
                           ₹{leg.legBudgetCPINR}
                           </span><br/>
                           <span className="section-sub-header-color  fs-14">
                            {currencyType.currency_type !== 1 && currencyType.currency_symbol || '$'}{leg[`legBudgetCP${currencyType.currency_type === 3 ? 'Secondary' : 'USD'}`]}
                           </span>
                           </Fragment> }
                     </div>
                     {/* <div className="flex col-6">
                                <div onClick={e => { }} className="flex flex-middle"><span className="pr-15">View </span><InfoIcon className="curP" onClick={() => handleShowCharges(true, leg)} /></div>
                            </div> */}
                  </div>
               })

                  : <div className="flex pv-20 border-bottom-light flex-between flex-middle" >
                     <div className="flex col-6">
                        <span className="section-sub-header-color  fs-14">
                           {lineItem.from}
                        </span>
                     </div>
                     <div className="flex col-6">
                        <span className="section-sub-header-color  fs-14">
                           {lineItem.to}
                        </span>
                     </div>
                     <div className="flex col-6">

                        <span className="section-sub-header-color  fs-14">
                           {lineItem.secKmRun}
                        </span>

                     </div>
                     <div className="flex col-6">

                        <span className="section-sub-header-color  fs-14">
                           {lineItem.secUptoKM}
                        </span>

                     </div>

                     <div className="flex col-6">

                        <span className="section-sub-header-color  fs-14">
                           {lineItem.secondaryQbr}
                        </span>

                     </div>
                     {/* <div className="flex col-6">
                                <div onClick={e => { }} className="flex flex-middle"><span className="pr-15">View </span><InfoIcon className="curP" onClick={() => handleShowCharges(true, leg)} /></div>
                            </div> */}
                  </div>}
         </div>







         {/* <div className="mt-40">
                <div className="flex flex-row flex flex-between">
                    <span className="section-sub-header-color fBold fs-16">
                        Costs
                </span>
                </div>
                <div className="flex pv-20 border-bottom-light flex-between flex-middle" >
                    <div className="flex flex-1 col-5">
                        <span className="section-sub-header-color fBold fs-14 op-5">
                            Cost Head
                    </span>
                    </div>
                    <div className="flex flex-1 col-5">
                        <span className="section-sub-header-color fBold fs-14 op-5">
                            MR
                    </span>
                    </div>
                    <div className="flex flex-1 col-5">
                        <span className="section-sub-header-color fBold fs-14 op-5">
                            LPP
                    </span>
                    </div>
                    <div className="flex flex-1 col-5">
                        <span className="section-sub-header-color fBold fs-14 op-5">
                            CP
                    </span>
                    </div>
                    <div className="flex flex-1 col-5">
                        <span className="section-sub-header-color fBold fs-14 op-5">
                            Currency name
                    </span>
                    </div>
                </div> */}
         {/* {
                    lineItem.costs.map((cost, index) => {
                        return <abbr title={cost.description} className="flex pv-20 border-bottom-light flex-between flex-middle" key={index}>
                            <div className="flex flex-1 col-5">
                                <span className="section-sub-header-color  fs-14">
                                    {cost.costHead}
                                </span>
                            </div>
                            <div className="flex flex-1 col-5">
                                <span className="section-sub-header-color  fs-14">
                                    {cost.mr}
                                </span>
                            </div>
                            <div className="flex flex-1 col-5">
                                <span className="section-sub-header-color  fs-14">
                                    {cost.lpp}
                                </span>
                            </div>
                            <div className="flex flex-1 col-5">
                                <span className="section-sub-header-color  fs-14">
                                    {cost.cp}
                                </span>
                            </div>
                            <div className="flex flex-1 col-5">
                                <span className="section-sub-header-color  fs-14">
                                    {cost.currencyName}
                                </span>
                            </div>
                        </abbr>
                    })

                } */}
         {/* </div>
            {showCharges && <Overlay>
                <div className="box-shadow br-5 pr flex">
                    <div className="wt-100p pt-20 pb-20 ht-400 overflowAuto">
                        <div className="pl-20 pr-20 pb-50">
                            <div className="flex flex-middle border-bottom-light-2 pb-10 mb-30">
                                <Heading text="Heading charges" className="flex-1" />
                                <div className="flex flex-between" >
                                    <div className="flex mr-20 curP" onClick={() => handleShowCharges(false, {})}>
                                        <CloseIcon className="theme-fill ht-12 wt-12 mr-5" />
                                        <span className="theme-color fs-14 fBold">Close</span>
                                    </div>
                                </div>
                            </div>
                            <div className="mb-40">
                                <div className="flex ht-30">
                                    <div className="wt-5p ht-20 mr-10">
                                        <div className="fSemibold fs-18 header-medium-color mb-5"></div>
                                    </div>
                                    <div className="wt-17p ht-20">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">Cost Head</div>
                                    </div>
                                    <div className="wt-12p ht-20 ml--59">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">Costing Type</div>
                                    </div>
                                    <div className="wt-12p ht-20">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">Description</div>
                                    </div>
                                    <div className="wt-12p ht-20 mr-5">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">MR</div>
                                    </div>
                                    <div className="wt-12p ht-20 mr-5">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">LPP</div>
                                    </div>
                                    <div className="wt-12p ht-20 mr-5">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">Budget</div>
                                    </div>
                                    <div className="wt-12p ht-20 mr-5">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">CP</div>
                                    </div>
                                </div>
                                <div className="">
                                    {
                                        leg.multiModeHeadingCharges != undefined && leg.multiModeHeadingCharges.length > 0 ? leg.multiModeHeadingCharges.map((hc, hcindex) => (
                                            <>
                                            <Fragment>
                                            <div key={`hc_${hcindex}`} className="flex mb-10 ht-40">
                                                <div className="wt-5p ht-30 mr-10">
                                                    {
                                                        hcindex + 1
                                                    }
                                                </div>
                                                <div className="wt-20p ht-30 ml-5">
                                                    <Input placeholder="Charges" value={hc.headingChargesValue} onChange={(e) => onHCChange(hcindex, e.target.value, e.target.name)} name="headingChargesValue" />
                                                </div>
                                                <div className="wt-20p ht-30 ml-5">
                                                    {/* <Dropdown
                                                        items={pricingBasis}
                                                        selectedItem={pricingBasis.find(pricingBasis => { return hc.headingChargesUnit === pricingBasis.value })}
                                                        name="headingChargesUnit"
                                                        onSelect={(e) => onHCChange(hcindex, e.value, 'headingChargesUnit')}
                                                        displayKey="name"
                                                        className="flex-1"
                                                        label="Select unit"
                                                    /> */}
         {/* <Dropdown
                                                items={[...COST_TYPE]}
                                                selectedItem={COST_TYPE.find(pricingBasis => { return hc.headingChargesUnit === pricingBasis.value })}
                                                name="headingChargesUnit"
                                                onSelect={(e) => onHCChange(hcindex, e.value, 'headingChargesUnit')}
                                               displayKey="name"
                                               className="flex-1"
                                               label="Select Cost Type"
                                            />
                                                </div>
                                                <div className="wt-20p ht-30 ml-5">
                                                    <Input placeholder="Desc" value={hc.headingChargesDescription}
                                                        onChange={(e) => onHCChange(hcindex, e.target.value, e.target.name)} name="headingChargesDescription" />
                                                </div>
                                                <div className="wt-20p ht-30 ml-5">
                                                    <Input placeholder="MR" value={hc.headingChargesMr} onChange={(e) => onHCChange(hcindex, e.target.value, e.target.name)} name="headingChargesMr" />
                                                </div>
                                                <div className="wt-20p ht-30 ml-5">
                                                    <Input placeholder="LPP" value={hc.headingChargesLpp} onChange={(e) => onHCChange(hcindex, e.target.value, e.target.name)} name="headingChargesLpp" />
                                                </div>
                                                <div className="wt-20p ht-30 ml-5">
                                                    <Input placeholder="Budget" value={hc.headingChargesBudget} onChange={(e) => onHCChange(hcindex, e.target.value, e.target.name)} name="headingChargesBudget" />
                                                </div>
                                                <div className="wt-20p ht-30 ml-5">
                                                    <Input placeholder="CP" value={hc.headingChargesCp} onChange={(e) => onHCChange(hcindex, e.target.value, e.target.name)} name="headingChargesCp" />
                                                </div>
                                                <div className="wt-20p ht-30 ml-5">
                                                <button 
                                                className="ht-40 br-5 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20"
                                                onClick={() => update(leg)}
                                            >Save</button>
                                            </div>
                                            </div>
                                            </Fragment>
                                            </>
                                        )) : 'No Heading charge added'
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Overlay>} */}
      </Fragment >
   )
}